import { render, staticRenderFns } from "./DisplayRichTextEditor.vue?vue&type=template&id=2d515c5c&scoped=true"
import script from "./DisplayRichTextEditor.vue?vue&type=script&lang=js"
export * from "./DisplayRichTextEditor.vue?vue&type=script&lang=js"
import style0 from "./DisplayRichTextEditor.vue?vue&type=style&index=0&id=2d515c5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d515c5c",
  null
  
)

export default component.exports